const url = window.location.hostname;
export const isSuperAdmin =
  url.includes('superadmin') || localStorage.getItem('superadmin') === 'true';
